import ReactQuill from 'react-quill-new';
 
import { useState, useEffect } from 'react';
import 'react-quill-new/dist/quill.snow.css';
import "quill-emoji/dist/quill-emoji.css";
import '../../../../../quill-fonts.css';
 
export default function BlockText({ block, setEditingBlock, updateBlock }) {
 
  
 

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
             
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
            ['clean'],
        ],
    };

    const formats = [
        'header', 'font', 'bold', 'italic', 'underline', 'strike',
        'color', 'background', 'align', 'list',
        'link',  
    ];

    function handleContentChange(value){
 
        block.content = value;
        updateBlock(block.id, 'content', value);
    }
 
    return (
        <div>
            <label className="block font-semibold mb-2">Texto:</label>
            <div className="p-2 bg-gray-100 rounded">
                <ReactQuill
                    value={block.content}
                    onChange={handleContentChange}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    preserveWhitespace={true}
                />
            </div>
        </div>
    );
}
